import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useState } from "react";
import yicela from "../../images/yicela.png";
import amir from "../../images/amir.png";

const title_color = "#0071BA";

const About = () => {
  const [readMore, setReadMore] = useState(true);
  const smallScreen600 = useMediaQuery("(min-width:600px)");
  const smallScreen1064 = useMediaQuery("(min-width:1064px)");
  return (
    <Box
      display={"flex"}
      gap={6}
      flexDirection={"column"}
      sx={{
        width: smallScreen1064 ? "1060px" : "100vw",
        margin: "0 auto",
        padding: "1.5rem",
        textWrap: "wrap",
      }}
    >
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Box sx={{ marginTop: "56px" }}></Box>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          About Our Company
        </Typography>
        <Typography variant="body1">
          {` Rawdat.AI was founded with the mission to remove process constraints
          imposed on developers. We offer a serverless platform that empowers
          developers to build a wide array of applications without the need for
          involvement from sysadmins, NetOps, or DevOps teams. By providing a
          seamless and limitless environment, Rawdat.AI enables developers to
        innovate and deploy their solutions efficiently and independently.
                  
        `}
        </Typography>
        <Typography variant="body1">
          In today's organizations, managing applications in production often
          requires coordination among distinct teams: NetOps, DevOps, and
          Developers. Developers frequently operate within limited sandbox
          environments, conducting code testing and deployment through pipelines
          supervised by DevOps and NetOps teams. Rawdat.AI strides in to
          dissolve these constraints, simplifying processes, accelerating
          workflows, and granting IT professionals newfound freedom. By erasing
          these barriers, Rawdat.AI empowers IT professionals to operate more
          efficiently and innovate with greater agility.
        </Typography>
      </Box>

      {/* MISSION */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          Company Mission
        </Typography>
        <Typography variant="body1" fontWeight={700}>
          Unleash the potential of developer innovation.
        </Typography>
        <Typography variant="body1">
          At Rawdat.AI, our mission is to empower developers from process
          constraints by offering a serverless platform that enables them to
          build diverse applications autonomously. We strive to simplify
          workflows, accelerate processes, and innovate with agility
        </Typography>
      </Box>

      {/* VISION */}
      <Box display={"flex"} gap={2} flexDirection={"column"}>
        <Typography variant="h4" sx={{ fontSize: "36px", color: title_color }}>
          Company Vision
        </Typography>
        <Typography variant="body1">
          At Rawdat.AI, our vision is to redefine the future of application
          development by creating a world where developers have the freedom to
          innovate without constraints. We envision a seamless ecosystem where
          our serverless platform empowers developers to unleash their
          creativity, simplifying workflows, accelerating processes, and
          fostering a culture of agile innovation.
        </Typography>
      </Box>

      {/* FOUNDER */}
      <Box
        display={"flex"}
        gap={12}
        flexDirection={smallScreen1064 ? "row" : "column"}
      >
        {   <Box display={"flex"} flexDirection={"column"} gap={3}>
          <Typography
            variant="h4"
            sx={{ fontSize: "36px", color: title_color }}
          >
            Our Team
          </Typography>
          
          <Box
            sx={{
              width: smallScreen600 ? "452px" : "300px",
              height: smallScreen600 ? "335px" : "225px",
              borderRadius: "10px",

              /*  background: `url(${yicela} lightgray 0px -121.52px / 103.982% 260.155% no-repeat`, */ 
            }}
          >
            <img
              src={amir}
              alt={"Amir"}
              width={smallScreen600 ? 452 : 300}
              height={smallScreen600 ? 335 : 225}
            />
          </Box>

          <Box display={"flex"} gap={1} flexDirection={"column"}>
            <Typography variant="body1" fontWeight={700}>
              Amir Rawdat-El-Balah
            </Typography>
            <Typography variant="body1" sx={{ color: "#888" }}>
              (Founder, Product Creator)
            </Typography>
          </Box>

          <Typography variant="body1">
            Amir is a well rounded engineer driven with an entrepreneurial
            spirit. He has a solid educational background in Computer
            Engineering with an option in business management and
            entrepreneurship. With 7+ years of professional experience in
            software development, technical marketing and solution building,
            Amir is passionate about building IT products that produce value in
            the marketplace. He continues to make significant contributions to
            the IT space with his publications.
          </Typography>
        </Box> }

        <Box display={"flex"} flexDirection={"column"} gap={3}>
          <Typography
            variant="h4"
            sx={{ fontSize: "36px", color: title_color }}
          >
            &nbsp;&nbsp;
          </Typography>

          {/* IMAGE */}

          <Box
            sx={{
              width: smallScreen600 ? "452px" : "300px",
              height: smallScreen600 ? "335px" : "225px",
              borderRadius: "10px",

              /*  background: `url(${yicela} lightgray 0px -121.52px / 103.982% 260.155% no-repeat`, */
            }}
          >
          
          <img
              src={yicela}
              alt={"Yicela"}
              width={smallScreen600 ? 452 : 300}
              height={smallScreen600 ? 335 : 225}
            />
          </Box>

          <Box display={"flex"} gap={1} flexDirection={"column"}>
            <Typography variant="body1" fontWeight={700}>
              Yicela Escobar Palomino
            </Typography>
            <Typography variant="body1" sx={{ color: "#888" }}>
              (Co-founder and Chief Operating Officer)
            </Typography>
          </Box>

          <Typography variant="body1">
            Yicela is a multilingual Business Management graduate from
            University of Ottawa. She has 15+ years of professional experience
            focused on Human Resources Management with a primary focus on
            Project Management, Client Management, Business Development,
            Training, and Recruitment & Selection. She has demonstrated a keen
            eye for talent, implementing strategic recruitment initiatives that
            have contributed to organizational revenue growth and success.
            Driven by a relentless pursuit of excellence, Yicela continues to
            make significant contributions to their field, leveraging their
            multifaceted skill set to drive innovation and achieve business
            objectives. Influenced by her work relationships with various IT
            professionals throughout her recruiting career. This exposure has
            ignited her interest in technology and programming languages. This
            experience has inculcated in her a desire to contribute to projects
            that facilitate faster job completion and streamline developer
            workflows.
          </Typography>

          {/*readMore ? (
            <Typography
              sx={{ color: title_color, cursor: "pointer" }}
              variant="body1"
              onClick={() => setReadMore((prevState) => !prevState)}
            >
              Learn more about Yicela
            </Typography>
          ) : (
            <>
              <Typography variant="body1">
                Yicela has focused on Human Resources Management with a primary
                focus on Client Management, Training, Mentoring, Recruitment &
                Selection. Over the course of her career, she has demonstrated a
                keen eye for talent, implementing strategic recruitment
                initiatives that have contributed to organizational growth and
                success. Furthermore, with 7+ years dedicated to training, they
                have played a pivotal role in developing and nurturing talent
                within their organizations.
              </Typography>

              <Typography variant="body1">
                Driven by a relentless pursuit of excellence, Yicela continues
                to make significant contributions to their field, leveraging
                their multifaceted skill set to drive innovation and achieve
                business objectives. Influenced by her work relationships with
                various IT professionals throughout her recruiting career. This
                exposure has ignited her interest in technology and programming
                languages. This experience has inculcated in her a desire to
                contribute to projects that facilitate faster job completion and
                streamline developer workflows.
              </Typography>
            </>
          )*/}
        </Box>
      </Box>

      <Box sx={{ marginBottom: "50px" }}></Box>
    </Box>
  );
};

export default About;
